import "core-js/modules/es.array.push.js";
import uploadImage from "./UploadAndCropSingleImage.vue";
import { getLocalImagePath } from "@/lang/getLocalImg.js";
import pixelArtList from "./pixelArtList.vue";
import pixelArtDetails from "./pixelArtDetails/index.vue";
import pixelArtDialog from "./pixelArtDetails/pixelArtDetails_Dialog.vue";
import { Product_Info } from "@/globalcfg.js";
import { post_Json_elk_statistic } from "@/jsUtils/nodejsRequest";
export default {
  name: "UploadForAllProduct",
  components: {
    uploadImage,
    pixelArtList,
    pixelArtDetails,
    pixelArtDialog
  },
  emits: ["startcrop", "showDetailDialog"],
  data() {
    return {
      uploading: false,
      showDetails: false,
      uploadUrl: '/imageprocesshost' + '/upload',
      //上传图片的接口
      createButImg: getLocalImagePath('imagetrans_upload_button'),
      //创建生成按钮
      product_type: "AllProducts",
      origingimgbase64: null,
      //原始图片裁剪后的base64
      loading_gif: require("@/assets/public/loading.gif"),
      //加载图标

      //当前请求下来的数据列表, 数据结构为{product_type: product_type, product_images: product_rebuildimages}
      currentDataList: [],
      //当前选中状态，用于判断选中的产品类型和产品类型中的序号，数据结构为{product_type: product_type, selectedstate：false, selected_index: selected_index}
      // 默认是第一产品的第一个像素画
      currentSelectedState: [],
      //当前选中的效果图, 数据结构为{smallimg: item, like : false, unlike: false, id : id, ldrname:ldrname}
      selectedEffectInfo: {
        smallimg: null,
        id: "",
        likestatus: false,
        unlikestatus: false,
        ldrname: "",
        product_type: "",
        color_numbers: []
      },
      selectedSmallImg: null,
      // 弹出图片详情的对话框
      isShowDialog: false,
      selectedParticleImg: null
    };
  },
  mounted: function () {
    this.getGenerateEffectData();
    $("#loading-icon").hide();
  },
  methods: {
    onBeforeUpload() {
      this.uploading = true;
      this.showDetails = false;

      // 清空当前数据
      if (this.currentDataList.length > 0) {
        this.currentDataList = [];
      }
      if (this.origingimgbase64 != null) {
        this.origingimgbase64 = null;
      }
      this.$refs.uploadImage_contain.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
      $("#loading-icon").show(); //显示加载图标
    },

    onUploadSucceed(res) {
      // console.log("generate all onUploadSucceed");

      let retdata = res.res;
      let origingimgbase64 = res.origingimgbase64;
      this.origingimgbase64 = origingimgbase64;

      // 将所有生成的效果图和相关信息都记录在rebuildimgs中，用于渲染
      let rebuilimgs = [];
      for (let i = 0; i < retdata.data.length; i++) {
        let product_type = retdata.data[i].product;
        let product_imgdata = retdata.data[i].data;
        let product_show_name = "";

        // console.log("product_imgdata type ", product_type);
        // console.log(product_imgdata);

        Object.keys(Product_Info).forEach((key, index) => {
          if (key == product_type) {
            product_show_name = Product_Info[key].show_name;
          }
        });
        let product_rebuildimages = [];
        for (let j = 0; j < product_imgdata.length; j++) {
          let item = 'data:image/jpg;base64,' + product_imgdata[j].image_base64;
          let id = product_imgdata[j].id;
          let ldrname = product_imgdata[j].ldr;
          let color_numbers_dict = product_imgdata[j].color_numbers;
          let color_numbers = [];
          if (color_numbers_dict != undefined && color_numbers_dict != null && Object.keys(color_numbers_dict).length > 0) {
            // 将color_numbers字典转换为数组
            Object.keys(color_numbers_dict).forEach((key, index) => {
              let color = color_numbers_dict[key];
              color_numbers.push(color);
            });
          }

          // 注意：结构要和pixelArtDetails中的selectedEffectInfo一致
          let imgdata = {
            smallimg: item,
            likestatus: false,
            unlikestatus: false,
            id: id,
            ldrname: ldrname,
            product_type: product_type,
            color_numbers: color_numbers
          };
          product_rebuildimages.push(imgdata);

          // console.log("rebuilimgs", rebuilimgs);
        }

        let product_data = {
          product_type: product_type,
          product_images: product_rebuildimages,
          product_show_name: product_show_name
        };
        rebuilimgs.push(product_data);
        let selectedstate = {
          product_type: product_type,
          selectedstate: false,
          selected_index: -1,
          product_show_name: product_show_name
        };
        this.currentSelectedState.push(selectedstate);
      }
      this.currentDataList = rebuilimgs;

      // console.log("on upload success  currentDataList", this.currentDataList.length);
      // console.dir(this.currentDataList);
      // 延时0.5秒，等待dom更新
      setTimeout(() => {}, 500);
      this.uploading = false;
      this.showDetails = false;

      // 将页面滚动到最下面，方便用户看到上传后的效果
      this.$refs.pixelArtList_contain.scrollIntoView();

      // 存储sessionStorage中，方便跳转到亚马逊后，重新进入时可以看到之前的效果
      sessionStorage.setItem("generate_effect_DataList", JSON.stringify(this.currentDataList));
      sessionStorage.setItem("current_selected_state", JSON.stringify(this.currentSelectedState));
      sessionStorage.setItem("current_crop_imagebase64", JSON.stringify(this.origingimgbase64));
    },
    onReceiveParticelResult(res) {
      // console.log("onReceiveParticelResult ---- ");
      // console.log(res);

      let retdata = res.res;
      let origingimgbase64 = res.origingimgbase64;
      if (this.origingimgbase64 == null) {
        this.origingimgbase64 = origingimgbase64;
      }

      // 将新生成的效果图和相关信息都记录在rebuildimgs中，用于渲染
      let rebuilimgs = [];
      // 如果retdata 中直接包含了product_type，那么就不需要再遍历了，直接使用retdata即可
      if (retdata.product != undefined && retdata.product != null) {
        let product_type = retdata.product;
        let product_imgdata = retdata.data;
        let product_show_name = "";

        // console.log("product_imgdata type ", product_type);
        // console.log(product_imgdata);

        Object.keys(Product_Info).forEach((key, index) => {
          if (key == product_type) {
            product_show_name = Product_Info[key].show_name;
          }
        });
        let product_rebuildimages = [];
        for (let j = 0; j < product_imgdata.length; j++) {
          let item = 'data:image/jpg;base64,' + product_imgdata[j].image_base64;
          let id = product_imgdata[j].id;
          let ldrname = product_imgdata[j].ldr;
          let color_numbers_dict = product_imgdata[j].color_numbers;
          let color_numbers = [];
          if (color_numbers_dict != undefined && color_numbers_dict != null && Object.keys(color_numbers_dict).length > 0) {
            // 将color_numbers字典转换为数组
            Object.keys(color_numbers_dict).forEach((key, index) => {
              let color = color_numbers_dict[key];
              color_numbers.push(color);
            });
          }

          // 注意：结构要和pixelArtDetails中的selectedEffectInfo一致
          let imgdata = {
            smallimg: item,
            likestatus: false,
            unlikestatus: false,
            id: id,
            ldrname: ldrname,
            product_type: product_type,
            color_numbers: color_numbers
          };
          product_rebuildimages.push(imgdata);

          // console.log("rebuilimgs", rebuilimgs);
        }

        let product_data = {
          product_type: product_type,
          product_images: product_rebuildimages,
          product_show_name: product_show_name
        };
        if (product_rebuildimages.length > 0) {
          this.currentDataList.push(product_data);
          let selectedstate = {
            product_type: product_type,
            selectedstate: false,
            selected_index: -1,
            product_show_name: product_show_name
          };
          this.currentSelectedState.push(selectedstate);
        }
      }

      // 将页面滚动到最下面，方便用户看到上传后的效果
      this.$refs.loadingicon.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    },
    onReceiveParticelEnd() {
      this.uploading = false;
      this.showDetails = false;
      $("#loading-icon").hide(); //隐藏加载图标

      // 将页面滚动到最下面，方便用户看到上传后的效果
      // this.$refs.pixelArtList_contain.scrollIntoView();

      // 存储sessionStorage中，方便跳转到亚马逊后，重新进入时可以看到之前的效果
      sessionStorage.setItem("generate_effect_DataList", JSON.stringify(this.currentDataList));
      sessionStorage.setItem("current_selected_state", JSON.stringify(this.currentSelectedState));
      sessionStorage.setItem("current_crop_imagebase64", JSON.stringify(this.origingimgbase64));
    },
    onUploadFailed() {},
    onStartcrop(imgurl) {
      this.$emit("startcrop", imgurl);
    },
    //裁剪成功
    onCropOk(imgurl) {
      this.$refs.uploadImage.onCutOk(imgurl);
    },
    //裁剪取消
    onCropCancel() {
      this.$refs.uploadImage.onCutCancel();
    },
    //当选择不同的像素画
    onSelectedPixelArt(item) {
      // console.log(item);

      let product_type = item.product_type;
      Object.keys(Product_Info).forEach((key, index) => {
        if (key == product_type) {
          this.selectedParticleImg = Product_Info[key].particle_img;
        }
      });
      for (let i = 0; i < this.currentSelectedState.length; i++) {
        if (this.currentSelectedState[i].product_type == product_type) {
          this.currentSelectedState[i].selectedstate = true;
          this.currentSelectedState[i].selected_index = i;
        } else {
          this.currentSelectedState[i].selectedstate = false;
          this.currentSelectedState[i].selected_index = -1;
        }
      }
      this.selectedEffectInfo = item.data;
      this.selectedSmallImg = item.data.smallimg;
      this.showDetails = true;
      this.isShowDialog = true;
      this.$emit("showDetailDialog", this.isShowDialog);

      // console.log("currentSelectedEffectInfo", this.selectedEffectInfo);
      // console.log("this isShowDialog ", this.isShowDialog);

      let imagename = this.selectedEffectInfo.id;
      let data = {
        "event": "page_home_click",
        "data": {
          "home_click_name": "PixelArt_Select_in_AllProducts",
          "home_click_data": imagename,
          "home_click_product_type": product_type
        }
      };
      post_Json_elk_statistic(data);
    },
    //点击关闭
    onCloseDialog() {
      this.isShowDialog = false;
      this.$emit("showDetailDialog", this.isShowDialog);
    },
    //点击喜欢
    onClicklike(imginfo) {
      // console.log("general onClicklike", imginfo);
      this.selectedEffectInfo.id = imginfo.id;
      this.selectedEffectInfo.likestatus = imginfo.likestatus;
      this.selectedEffectInfo.unlikestatus = imginfo.unlikestatus;
      this.selectedEffectInfo.product_type = imginfo.product_type;
      // currentDataList 需要更新，将当前选中的图片的like状态更新
      // 数据结构为{product_type: product_type, product_images: product_rebuildimages}
      for (let i = 0; i < this.currentDataList.length; i++) {
        if (this.currentDataList[i].product_type == imginfo.product_type) {
          for (let j = 0; j < this.currentDataList[i].product_images.length; j++) {
            if (this.currentDataList[i].product_images[j].id == imginfo.id) {
              this.currentDataList[i].product_images[j].likestatus = imginfo.likestatus;
              this.currentDataList[i].product_images[j].unlikestatus = imginfo.unlikestatus;
              break;
            }
          }
        }
      }
    },
    // 从sessionStorage中获取数据
    getGenerateEffectData() {
      let generate_effect_DataList = sessionStorage.getItem("generate_effect_DataList");
      if (generate_effect_DataList != undefined && generate_effect_DataList != null) {
        this.currentDataList = JSON.parse(generate_effect_DataList);
      }
      let current_selected_state = sessionStorage.getItem("current_selected_state");
      if (current_selected_state != undefined && current_selected_state != null) {
        this.currentSelectedState = JSON.parse(current_selected_state);
      } else {
        if (this.currentDataList != null) {
          for (let i = 0; i < this.currentDataList.length; i++) {
            let selectedstate = {
              product_type: this.currentDataList[i].product_type,
              selectedstate: false,
              selected_index: -1,
              product_show_name: this.currentDataList[i].product_show_name
            };
            this.currentSelectedState.push(selectedstate);
          }
        }
      }

      // 显示裁剪的图
      let current_crop_imagebase64 = sessionStorage.getItem("current_crop_imagebase64");
      if (current_crop_imagebase64 != undefined && current_crop_imagebase64 != null) {
        this.origingimgbase64 = JSON.parse(current_crop_imagebase64);
        this.$refs.uploadImage.showLocalImage(this.origingimgbase64);
      }
    }
  }
};